import { encryptedToRS } from './RSASign'
import { objectToQueryString } from './util'

const domains = [
  'stardustworld.cn',
  'stardustgod.com',
  'crazymaplestudios.com',
  'reelshort.com',
  'b25drama.com',
  'b25game.com',
]
const regexPattern = `^(https?:\\/\\/)?(?:[\\w-]+\\.)?(${domains.join(
  '|'
)})(\\/?|$)`
const regex = new RegExp(regexPattern)

const purchaseLinkParams = (
  url: string,
  extraParams: Record<string, unknown> = {}
) => {
  const appParams = JSON.parse(sessionStorage.getItem('headerFromApp') || '{}')

  /* 指定的项目和域名，添加加密参数 */
  if (regex.test(url) && ['cm1009', 'cm1012', 'cm1015', 'cm1017'].includes(appParams?.appid)) {
    const sign = encryptedToRS({
      ...appParams,
      uuid: `${appParams?.uuid}`?.slice?.(4)
    })
    const queryStr = objectToQueryString({
      ...extraParams,
      ...(appParams?.language ? { lang: appParams.language } : {}),
      sign
    })
    const newURL = url.includes('?')
      ? `${url}&${queryStr}`
      : `${url}?${queryStr}`
    return newURL
  }

  /* 默认返回 */
  const queryStr = objectToQueryString({ ...extraParams })
  const newURL = url.includes('?') ? `${url}&${queryStr}` : `${url}?${queryStr}`
  return newURL
}

export default purchaseLinkParams
